import React from "react";

import { useQuery } from "@apollo/client";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import parsePhoneNumberFromString from "libphonenumber-js";
import { makeStyles, withStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { colors } from "@/theme/overrides/colors";

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
  },
  header: {
    display: "flex",
    padding: theme.spacing(2, 3, 4, 3),
    backgroundColor: colors.white,
    marginBottom: theme.spacing(2),
  },
  headerText: {
    fontSize: "18px",
    fontWeight: "bold",
  },
  content: {
    display: "flex",
    backgroundColor: colors.white,
    width: "80%",
    padding: theme.spacing(4),
  },
  profileInfo: {
    display: "flex",
    flexDirection: "column",
  },
  profileInfoContainer: {
    display: "flex",
    backgroundColor: colors.white,
    padding: theme.spacing(2),
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#EDF0F5",
  },
  table: {
    tableLayout: "fixed",
  },
  loadingView: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
const StyledTableCell = withStyles(TableCell, {
  root: {
    borderBottom: "none",
  },
});

export const personalInfoQuery = graphql(`
  query PersonalInfo {
    coachViewer {
      id
      account {
        id
        email
      }
      profile {
        firstName
        middleName
        lastName
        gender
        dateOfBirth
        mobileNumber
        occupation
        country
        avatar {
          id
          signedId
        }
        avatarUrl
      }
    }
  }
`);

const PersonalInfo: React.FC = () => {
  const { classes: styles } = useStyles();
  const { data, loading } = useQuery(personalInfoQuery);
  const personalInfo = data?.coachViewer;
  const email = personalInfo?.account.email;
  const firstName = personalInfo?.profile?.firstName;
  const lastName = personalInfo?.profile?.lastName;
  const middleName = personalInfo?.profile?.middleName;
  const dateOfBirth = personalInfo?.profile?.dateOfBirth;
  const gender = personalInfo?.profile?.gender.toLocaleLowerCase();
  const mobileNum = personalInfo?.profile?.mobileNumber;
  const mobileNumFormatted =
    mobileNum != null
      ? parsePhoneNumberFromString(mobileNum, "PH")?.format("INTERNATIONAL")
      : "";

  if (loading) {
    return (
      <div className={styles.loadingView}>
        <Typography variant="h6" color="textPrimary">
          Loading...
        </Typography>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <Box className={styles.header}>
        <Typography variant="h6" color="textPrimary">
          Personal Information
        </Typography>
      </Box>

      <Box className={styles.content}>
        <Table className={styles.table}>
          <TableBody>
            <TableRow>
              <StyledTableCell>
                <Box className={styles.profileInfo}>
                  <Typography variant="subtitle1" color="textSecondary">
                    First Name
                  </Typography>
                  <Box className={styles.profileInfoContainer}>{firstName}</Box>
                </Box>
              </StyledTableCell>

              <StyledTableCell>
                <Box className={styles.profileInfo}>
                  <Typography variant="subtitle1" color="textSecondary">
                    Last Name
                  </Typography>
                  <Box className={styles.profileInfoContainer}>{lastName}</Box>
                </Box>
              </StyledTableCell>
            </TableRow>

            <TableRow>
              <StyledTableCell>
                <Box className={styles.profileInfo}>
                  <Typography variant="subtitle1" color="textSecondary">
                    Middle Name
                  </Typography>
                  <Box className={styles.profileInfoContainer}>
                    {middleName}
                  </Box>
                </Box>
              </StyledTableCell>

              <StyledTableCell>
                <Box className={styles.profileInfo}>
                  <Typography variant="subtitle1" color="textSecondary">
                    Email
                  </Typography>
                  <Box className={styles.profileInfoContainer}> {email} </Box>
                </Box>
              </StyledTableCell>
            </TableRow>

            <TableRow>
              <StyledTableCell>
                <Box className={styles.profileInfo}>
                  <Typography variant="subtitle1" color="textSecondary">
                    Birth Date
                  </Typography>
                  <Box className={styles.profileInfoContainer}>
                    {dateOfBirth}
                  </Box>
                </Box>
              </StyledTableCell>

              <StyledTableCell>
                <Box className={styles.profileInfo}>
                  <Typography variant="subtitle1" color="textSecondary">
                    Gender
                  </Typography>
                  <Box className={styles.profileInfoContainer}> {gender} </Box>
                </Box>
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell>
                <Box className={styles.profileInfo}>
                  <Typography variant="subtitle1" color="textSecondary">
                    Mobile Number
                  </Typography>
                  <Box className={styles.profileInfoContainer}>
                    {mobileNumFormatted}
                  </Box>
                </Box>
              </StyledTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </div>
  );
};

export default PersonalInfo;
